import(/* webpackMode: "eager", webpackExports: ["FantasyPageClient"] */ "/vercel/path0/apps/prono-rtbf/app/fantasy/FantasyPageClient.tsx");
